/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Missing_Dialogue_NameInputs */



/**
* | output |
* | --- |
* | "Missing Dialogue 0{index}" |
*
* @param {Missing_Dialogue_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const missing_dialogue_name = /** @type {((inputs: Missing_Dialogue_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Dialogue_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dialogue manquant 0${i?.index}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehlender Dialog 0${i?.index}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Dialogo mancante 0${i?.index}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отсутствующий диалог 0${i?.index}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Diálogo faltante 0${i?.index}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`缺失对话 0${i?.index}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`会話が欠落しています 0${i?.index}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`संवाद गायब है 0${i?.index}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Diálogo ausente 0${i?.index}`)
	return /** @type {LocalizedString} */ (`Missing Dialogue 0${i?.index}`)
});